<template>
  <div class="condition-select condition-form-item">
    <el-divider />

    <p class="input-label">{{ config.name }}</p>
    <el-select v-model="value" size="medium">
      <el-option v-for="item in operations" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object
    }
  },
  computed: {
    operations() {
      if (this.config.valueFrom === "direct") {
        return this.config.selectValue;
      }
    },
    selectedObj() {
      return this.operations.find(item => item.id === this.value);
    }
  },
  data() {
    return {
      value: ""
    };
  }
};
</script>

<style scoped lang="scss">
@import "../common.scss";
</style>